import type { EditorPointerAPI } from './publicApiKey';

export function createEditorPointerApi(): EditorPointerAPI {
  return {};
}
